import { toast } from "react-toastify";
import api from "../config/apiConfig";
import { getAdminId, getRegisterId } from "../utils/authId";
import {
  getSelectedActivity,
  getSelectedCompany,
  getSelectedDms,
  getSelectedPerson,
  getUserDetails,
  storeSelectedActivity,
  storeSelectedDms,
  storeSelectedPerson,
} from "../utils/auth";

export const viewGroupAPi = async (data) => {
  const id = getRegisterId();
  const user = getUserDetails() || {};

  try {
    const response = await api.get(
      `api/get_group_chat/?admin_id=${id}${data}&other_user=${user.role}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Create Group

export const createGroup = async (formData) => {
  const id = getAdminId();
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    group_name: formData.group_name,
    group_user: JSON.stringify(formData.group_user), // Already an array
    group_admin: JSON.stringify(formData.group_admin), // Already an array
    company: JSON.stringify([formData.company]),
    admin: id,
    group_icon: formData.group_icon,
    edited_company: companyId.id,
    edited_by_id: regId,
  };

  try {
    const response = await api.post("api/add_group_chat/", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response) {
      toast.success("Group Created sucessfully", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (errors) {
    throw errors;
  }
};

// Fetch Selected Group

export const FetchSelectedGroupAPi = async (data) => {
  try {
    const response = await api.get(`api/selected_group_details/${data}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Edit Group

export const EditGroup = async (id, updates) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    ...updates,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(`api/edit_group/${id}/`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Group Updated successful!", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });

    const groupName = response.data.update_group[0].name;
    const groupIcon = response.data.update_group[0].emp_pic;
    const groupid = response.data.update_group[0].group_id;
    const selectedPerson = getSelectedPerson(); // Should decrypt like getSelectedCompany()
    const selectedDms = getSelectedDms();
    const selectedActivity = getSelectedActivity();

    if (selectedPerson && selectedPerson.group_id === groupid) {
      storeSelectedPerson({
        ...selectedPerson,
        name: groupName,
        emp_pic: groupIcon,
      });
    }

    if (selectedDms && selectedDms.group_id === groupid) {
      storeSelectedDms({
        ...selectedDms,
        name: groupName,
        emp_pic: groupIcon,
      });
    }

    if (selectedActivity && selectedActivity.group_id === groupid) {
      storeSelectedActivity({
        ...selectedActivity,
        name: groupName,
        emp_pic: groupIcon,
      });
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const EditGroupAcess = async (id, updates) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    ...updates,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(
      `api/group_update_admin_people/${id}/`,
      data
    );
    if (response) {
      toast.success("Updated sucessfully", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Group Status Update

export const UpdateStatusGroupApi = async (formData) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    ...formData,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(`api/group_active_deactive/`, data);
    if (response) {
      toast.success("Update successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (error) {}
};
